import React, { useState, useEffect } from 'react';
import { CircularProgress, Grid, Button, Typography } from '@material-ui/core';
import SendIcon from '@mui/icons-material/ArrowForward';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import axios from 'axios';
import Parser from 'html-react-parser';
import { Link } from 'react-router-dom';
import { Pagination, Navigation } from 'swiper/modules';

import './styles.css';
import { useDevice } from 'components/DeviceContext.js';

const NewsComponent = () => {
    const [noticias, setNoticias] = useState([]);
    const [loading, setLoading] = useState(true);
    const {isMobile, isLaptop} = useDevice();

    const removeImages = (htmlContent) => {
        const modifiedContent = htmlContent.replace(/<img.*?>/g, '');
        return modifiedContent;
    };

    const shortenText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength - 3) + '...';
        } else {
            return text;
        }
    };

    useEffect(() => {
        axios
            .get('https://cnm.org.br/api/noticias?&categoria=financas&sort=created_at&order=desc')
            .then((response) => {
                const noticiasData = response.data.noticias.data.map((noticia) => {
                    if (!noticia.imagem.startsWith('http') && !noticia.imagem.startsWith('www')) {
                        noticia.imagem = `https://cnm.org.br${noticia.imagem}`;
                    }

                    noticia.conteudo = noticia.conteudo.replace(/[^\x20-\x7E]/g, '');
                    return noticia;
                });
                setNoticias(noticiasData);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Erro ao obter notícias:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <Grid container style={{ padding: isMobile ? '0' : '2.6em', height: isMobile ? '78vh' :  isLaptop ? '62vh' : '50vh' }}>

            <Swiper
                style={{
                    // '--swiper-navigation-color': '#fff',
                    // '--swiper-pagination-color': '#fff',
                }}
                // lazy={true}
                // pagination={{
                //     clickable: true,
                // }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
            >
                {noticias.map((article, index) => (
                    <SwiperSlide key={index}>
                        <Grid style={{ width: isMobile ? '90%' : '70%' }}>

                            <Grid container style={{ textAlign: 'left' }}>
                                <Grid item xs={12} md={6}>
                                    <img
                                        src={article.imagem}
                                        alt={article.titulo}
                                        loading="lazy"
                                        style={{ width: '100%', height: 'auto', maxHeight: '350px' }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} style={{ paddingLeft: isMobile ? '1em' : '50px', fontWeight: '700', fontSize: isLaptop ? '15px' : '15px', textAlign: isMobile ? 'center' : '' }}>
                                    <span style={{ color: 'var(--azul-claro)' }}>{article.categorias} </span>
                                    <span style={{ color: 'black' }}> • </span>
                                    <span style={{ color: 'var(--azul-claro)' }}>{article.datetime} </span>
                                    <Typography gutterBottom variant="h5" component="h2" style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: isMobile ? '1em' : isLaptop ? '1.4em' : '1.9em', color: 'var(--azul)', textAlign: 'left', fontWeight: '600', maxHeight: 136 }}>
                                        {article.titulo}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="div" style={{ overflow: 'hidden', textOverflow: 'ellipsis', fontSize: isMobile ? '0.9em' : '1.1em', textAlign: 'left', color: 'var(--cinza)' }}>
                                        {Parser(removeImages(shortenText(article.conteudo, 400)))}
                                    </Typography>
                                <Grid item xs={12} style={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-end' }}>
                                    <Button
                                        style={{
                                            backgroundColor: 'var(--azul-claro)',
                                            color: 'var(--branco)',
                                            position: 'relative',
                                            marginTop: isLaptop ? '0' : '10px',
                                            // marginBottom : '1em',
                                            borderRadius: '2em',
                                            textTransform: 'initial'
                                        }}
                                        component={Link}
                                        to={`/noticia/${article.id}`}
                                        size="large"
                                    > <span style={{textTransform: 'uppercase'}}>v</span>eja  a notícia completa
                                        <SendIcon />
                                    </Button>
                                </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Grid>
    );
};

export default NewsComponent;
